import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetMeNotifiedService {
  openModal: boolean = false;
  modalObservable = new BehaviorSubject([]);
  isPreOrder = this.modalObservable.asObservable();

  @Output()
  update: EventEmitter<boolean> = new EventEmitter();

  constructor(private _http: HttpClient) {}

  addSubscriber(data, formId): Observable<any> {
    return this._http.post(
      `https://api.convertkit.com/v3/forms/${formId}/subscribe`,
      data
    );
  }

  setPreOrderStatus(status) {
    this.modalObservable.next(status);
  }

  toggle() {
    this.openModal = !this.openModal;
    this.update.emit(this.openModal);
  }
}
